module.exports = __webpack_public_path__ + "static/cabina-de-conductor---cupula-04879e4a711cfc71fa7ad63c0a9e52a2.jpg";